"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _NotificationDialog = require("./NotificationDialog.style");

var _IconClose = _interopRequireDefault(require("../../Icons/IconClose"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _DarkButton = _interopRequireDefault(require("../../Button/DarkButton"));

// import DarkText from '../../../DarkText';
var getTexts = function getTexts(type, item) {
  var titleText = '';
  var descriptionText = '';

  if (type === 'screenShare') {
    titleText = "".concat(item.user.name, " wants to share their screen");
    descriptionText = "Once approved, ".concat(item.user.name, " can share their screen on stage.");
  }

  if (type === 'setAssetStage') {
    titleText = "Set \"".concat(item.asset.name, "\" as main stage");
    descriptionText = "".concat(item.user.name, " wants to set \"").concat(item.asset.name, "\" asset as main stage.");
  }

  if (type === 'waitingForTeacherApproval') {
    titleText = 'Waiting for teacher’s approval';
    descriptionText = 'Screen sharing request has been sent to teacher. Once approved, you can share your screen on stage.';
  }

  if (type === 'teacherApproved') {
    titleText = 'Teacher has approved screen share';
    descriptionText = 'Teacher has approved your screen share request. To start, click on the start screen share button below.';
  }

  return {
    titleText: titleText,
    descriptionText: descriptionText
  };
};

var renderItem = function renderItem(item, activeItem, totalItems, prevClick, nextClick, onCloseClick, className) {
  var _getTexts = getTexts(item.type, item),
      titleText = _getTexts.titleText,
      descriptionText = _getTexts.descriptionText;

  var textInPlaceOfCounter = item.textInPlaceOfCounter,
      _item$showCancelButto = item.showCancelButton,
      showCancelButton = _item$showCancelButto === void 0 ? true : _item$showCancelButto,
      _item$showOkButton = item.showOkButton,
      showOkButton = _item$showOkButton === void 0 ? true : _item$showOkButton,
      _item$cancelButtonTex = item.cancelButtonText,
      cancelButtonText = _item$cancelButtonTex === void 0 ? 'Decline' : _item$cancelButtonTex,
      _item$okButtonText = item.okButtonText,
      okButtonText = _item$okButtonText === void 0 ? 'Allow' : _item$okButtonText,
      _item$onOkClick = item.onOkClick,
      onOkClick = _item$onOkClick === void 0 ? function () {} : _item$onOkClick,
      _item$onCancelClick = item.onCancelClick,
      onCancelClick = _item$onCancelClick === void 0 ? function () {} : _item$onCancelClick;
  return _react.default.createElement(_NotificationDialog.NotificationItemWrapper, {
    className: (0, _classnames.default)(className)
  }, _react.default.createElement(_NotificationDialog.CloseButton, {
    onClick: onCloseClick
  }, _react.default.createElement(_IconClose.default, {
    style: {
      fill: '#ededed'
    }
  })), (prevClick || nextClick) && _react.default.createElement(_NotificationDialog.NavigationButtons, null, _react.default.createElement("span", {
    onClick: prevClick,
    role: "presentation"
  }, _react.default.createElement(_Icon.default, {
    type: "arrow-left",
    className: {
      disabled: !prevClick
    }
  })), _react.default.createElement("span", {
    onClick: nextClick,
    role: "presentation"
  }, _react.default.createElement(_Icon.default, {
    type: "arrow-right",
    className: {
      disabled: !nextClick
    }
  }))), _react.default.createElement(_NotificationDialog.RequestCounter, null, textInPlaceOfCounter || "REQUEST ".concat(activeItem + 1, " OF ").concat(totalItems)), _react.default.createElement(_NotificationDialog.Title, null, titleText), _react.default.createElement(_NotificationDialog.Description, null, descriptionText), showCancelButton && _react.default.createElement(_DarkButton.default.SecondaryButton, {
    style: {
      marginRight: '20px'
    },
    onClick: onCancelClick
  }, cancelButtonText), showOkButton && _react.default.createElement(_DarkButton.default, {
    onClick: onOkClick
  }, okButtonText));
};

var NotificationItem = function NotificationItem(_ref) {
  var items = _ref.items,
      className = _ref.className,
      onCancelClick = _ref.onCancelClick,
      onOkClick = _ref.onOkClick,
      onCloseClick = _ref.onCloseClick;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      activeItem = _useState2[0],
      setActiveItem = _useState2[1];

  var prevClick = activeItem > 0 ? function () {
    return setActiveItem(activeItem - 1);
  } : null;
  var nextClick = activeItem < items.length - 1 ? function () {
    return setActiveItem(activeItem + 1);
  } : null;
  return renderItem(items[activeItem], activeItem, items.length, prevClick, nextClick, onCloseClick, className);
};

NotificationItem.defaultProps = {
  className: '',
  items: [],
  onCloseClick: function onCloseClick() {},
  showOkButton: true,
  showCancelButton: true,
  okButtonText: 'Allow',
  cancelButtonText: 'Decline',
  textInPlaceOfCounter: null
};
NotificationItem.propTypes = {
  className: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    type: _propTypes.default.string.isRequired,
    user: _propTypes.default.shape({
      pid: _propTypes.default.string,
      name: _propTypes.default.string
    }),
    asset: _propTypes.default.shape({
      pid: _propTypes.default.string,
      name: _propTypes.default.string
    }),
    textInPlaceOfCounter: _propTypes.default.string,
    onOkClick: _propTypes.default.func,
    onCancelClick: _propTypes.default.func,
    onCloseClick: _propTypes.default.func,
    showOkButton: _propTypes.default.bool,
    showCancelButton: _propTypes.default.bool,
    okButtonText: _propTypes.default.string,
    cancelButtonText: _propTypes.default.string
  })).isRequired
};
var _default = NotificationItem;
exports.default = _default;